import type { PageSeo } from "./PageSeo.js";

function upsertMeta(attr: "name" | "property", key: string, content: string): void {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/** Applies a PageSeo to document.head (title, meta, OG, canonical, JSON-LD). Browser only. */
export function applyHead(seo: PageSeo): void {
  document.title = seo.title;
  for (const t of seo.metaTags()) {
    if (t.name) upsertMeta("name", t.name, t.content);
    else if (t.property) upsertMeta("property", t.property, t.content);
  }
  let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "canonical";
    document.head.appendChild(link);
  }
  link.href = seo.url();
  let ld = document.head.querySelector<HTMLScriptElement>("script#ld-json");
  if (!ld) {
    ld = document.createElement("script");
    ld.type = "application/ld+json";
    ld.id = "ld-json";
    document.head.appendChild(ld);
  }
  ld.textContent = JSON.stringify(seo.jsonLd());
}
